<template>
  <div>
    <a-spin :spinning="spinning" tip="正在导出...">
      <div class="overflow-hidden">
        <div class="float-left" style="width: 128px; overflow-y: auto">
          <div
            class="pt-6"
            :style="
              store.getters.getConfig.is_header
                ? 'min-height: calc(100vh - 135px)'
                : 'min-height: calc(100vh - 115px)'
            "
          >
            <Menu :selectedKeys="[0]"></Menu>
          </div>
        </div>
        <div class="float-right" style="width: calc(100% - 128px)">
          <a-card style="" :bordered="false">
            <!-- <a-result v-if="!applyStatus" title="您还没有完成相关认证">
              <template slot="extra">
                <a-button
                  v-if="userInfo.review != 2"
                  key="console"
                  type="primary"
                  @click="
                    () => {
                      $router.push(`/admin/info`);
                    }
                  "
                  >实名认证</a-button
                >
                <a-button
                  v-if="!permission(['contract', 'apply/:id?'], 'bind_company') && !userInfo.companys"
                  @click="
                    () => {
                      $router.push('/admin/company');
                    }
                  "
                  key="console"
                  type="primary"
                  >企业认证</a-button
                >
              </template>
            </a-result> -->
            <div>
              <div class="search-container" style="display: flex;">
                <div 
                  class="search-box-wrapper"
                  :style="{ height: isCollapsed ? '45px' : 'auto' }"
                >
                  <div class="flex flex-wrap gap-4 pb-6">
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">编号:</span>
                      <a-textarea
                        style="width: 200px"
                        autoSize
                        v-model="queryParam.like.code"
                        @pressEnter="press_enter"
                      ></a-textarea>
                    </div>
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">申请人:</span>
                      <a-textarea
                        style="width: 200px"
                        autoSize
                        v-model="queryParam.like.bidder"
                        @pressEnter="press_enter"
                      ></a-textarea>
                    </div>
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">项目名称:</span>
                      <a-textarea
                        style="width: 200px"
                        autoSize
                        v-model="queryParam.like.project"
                        @pressEnter="press_enter"
                      ></a-textarea>
                    </div>
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">出函日期:</span>
                      <a-range-picker
                        v-model="queryParam.time.sign_time"
                        format="YYYY-MM-DD"
                        valueFormat="YYYY-MM-DD"
                      />
                    </div>
                    <div class="flex items-center">
                      <span class="pr-2 leading-8">开标日期:</span>
                      <a-range-picker
                        v-model="queryParam.time.kbdate"
                        format="YYYY-MM-DD"
                        valueFormat="YYYY-MM-DD"
                      />
                    </div>
                  </div>
                </div>
                <div class="flex gap-2" style="font-size: 12px">
                  <button
                    class="px-2 text-blue-500 hover:text-blue-700 transition-colors flex items-center"
                    @click="toggleSearchBox"
                    style="white-space: nowrap;" 
                  >
                    <span class="px-1">{{ isCollapsed ? '展开' : '收缩' }}</span>
                    <a-icon :type="isCollapsed ? 'down' : 'up'"/>
                  </button>
                  <a-button type="primary" @click="gets(1)"><a-icon type="search"></a-icon>搜索</a-button>
                  <a-button type="default" @click="reset" icon="reload">重置</a-button>
                </div>
              </div>
              <div class="overflow-hidden">
                <div class="float-left pb-6 overflow-hidden" style="width: calc(100% - 240px)">
                  <div
                    v-for="(item, index) in tabs"
                    :key="index"
                    class="float-left cursor-pointer"
                    :class="['px-8 py-2', statusKey == item.key ? 'status-active' : 'status']"
                    @click="statusTabClick(item.key)"
                  >
                    <a-badge :count="item.count" :offset="[12, 5]" v-if="index >= 1 && index <= 4">
                      <div class="flex flex-col items-center">
                        <img class="w-10 h-10" :src="item.icon" />
                        <div class="pt-2">{{ item.name }}</div>
                      </div>
                    </a-badge>
                    <div v-else class="flex flex-col items-center">
                      <img class="w-10 h-10" :src="item.icon" />
                      <div class="pt-2">{{ item.name }}</div>
                    </div>
                  </div>
                </div>
                <div class="float-right overflow-hidden" style="width: 240px">
                  <a-button class="float-right mt-7" icon="plus" type="primary" @click="apply">在线申请</a-button>
                  <a-button 
                    v-if="permission(['contract'], 'exportReport')"
                    class="float-right mt-7 mr-2" 
                    type="primary" 
                    @click="exportReport"
                  ><a-icon type="file-excel" />报表导出
                  </a-button>
                </div>
              </div>
              <a-table
                :loading="loading"
                :columns="columns"
                :data-source="list"
                :pagination="pagination"
                bordered
                row-key="id"
                size="small"
              >
                <template slot="status" slot-scope="text">
                  <span :class="findByKey(contractStatus, 'id', text, 'color')">{{
                    findByKey(contractStatus, 'id', text, 'name')
                  }}</span>
                </template>
                <template slot="code" slot-scope="text, record">
                  <text-highlight :queries="[search]" :title="text">
                    {{ record.prefix + text }}</text-highlight
                  >
                </template>
                <template slot="proprietor" slot-scope="text">
                  <text-highlight :queries="[search]" :title="text"> {{ text }}</text-highlight>
                </template>
                <template slot="bidder" slot-scope="text">
                  <text-highlight :queries="[search]" :title="text"> {{ text }}</text-highlight>
                </template>
                <template slot="project" slot-scope="text">
                  <text-highlight :queries="[search]" :title="text">{{ text }}</text-highlight>
                </template>
                <template slot="action" slot-scope="text, record">
                  <span>
                    <a
                      @click="$router.push(`/admin/contract_detail/${text}`)"
                      v-if="record.status == 4"
                      class="text-yellow-500"
                      >支付</a
                    >
                    <a-divider v-if="record.status == 4" type="vertical"></a-divider>
                    <a @click="download(record)" v-if="record.status >= 5" class="text-green-500"
                      >下载</a
                    >
                    <a-divider v-if="record.status >= 5" type="vertical"></a-divider>
                    <a
                      v-if="record.status >= 3"
                      class="text-green-500"
                      @click="preview(record)"
                      >预览</a
                    >
                    <a-divider v-if="record.status >= 3" type="vertical"></a-divider>
                    <a
                      @click="godetail(record)"
                      v-if="record.status >= 3 || record.category_id != 2"
                      class="text-green-500"
                      >详情</a
                    >
                    <a-divider
                      v-if="record.status >= 3 || record.category_id != 2"
                      type="vertical"
                    ></a-divider>
                    <a
                      v-if="(record.status == 2 || record.status == 7) && userInfo.id == record.user_id"
                      class="text-red-500"
                      @click="confirmDelete(record)"
                      >删除</a
                    >
                  </span>
                </template>
              </a-table>
            </div>
            <a-modal
              :visible="previewflag"
              @cancel="previewflag = false"
              title="预览"
              :footer="null"
              width="1000px"
            >
              <Preview :info="previewInfo"></Preview>
            </a-modal>
            <Download
              :visible="downloadflag"
              @cancel="downloadflag = false"
              :info="downloadInfo"
            ></Download>
            <a-modal
              title="请选择申请保函类型"
              :visible="applyModalFlag"
              :confirm-loading="confirmLoading"
              @ok="applyModalOk"
              @cancel="applyModalCancel"
            >
              <a-radio-group v-model="apply_radio_value">
                <a-radio :style="radioStyle" :value="1"> 其他保函</a-radio>
                <a-radio :style="radioStyle" :value="2"> 投标保函 </a-radio>
              </a-radio-group>
            </a-modal>
          </a-card>
        </div>
      </div>
    </a-spin>
  </div>
</template>
<script>
  import { mapGetters } from 'vuex';
  import { merge } from 'lodash';
  import { tabs, useColumn } from './_index';
  import { contractStatusCount, contracts, contract_statuss, contract_del, exportContracts } from '@/api/contract';
  import Menu from '@/views/admin/menu/index';
  import permission from '@/utils/permission';
  import { findByKey } from '@/utils/tool';
  import Preview from './module/preview.vue';
  import Download from './module/download.vue';
  import { isIE9, isIE } from '@/utils/tool';
  import store from '@/store/index';
  import { downloadUrl } from '@/utils/download';
  export default {
    components: {
      Menu,
      Preview,
      Download,
    },
    data() {
      return {
        isCollapsed: true,
        queryParam: { custom: { search: '', offset_months: '-3' }, time: {}, in: {}, like: {} },
        columns: useColumn(permission(['contract', 'apply/:id?'], 'bind_company')),
        pagination: {
          current: 1,
          pageSize: 10,
          pageSizeOptions: ['10', '20', '50'],
          showSizeChanger: true,
          onChange: (page, pageSize) => {
            this.pagination.current = page;
            this.pagination.pageSize = pageSize;
            this.gets();
          },
          onShowSizeChange: (current, size) => {
            this.pagination.current = current;
            this.pagination.pageSize = size;
            this.gets();
          },
          showTotal: (total) => this.formatTotalText(total),
        },
        loading: true,
        spinning: false,
        statusKey: '',
        list: [],
        tabs,
        contractStatus: [],
        previewflag: false,
        previewInfo: {},
        downloadflag: false,
        downloadInfo: {},
        search: '',
        store: store,
        applyModalFlag: false,
        apply_radio_value: 1,
        totalPoundage: 0,
      };
    },
    computed: {
      ...mapGetters({
        userInfo: 'userInfo',
      }),
      applyStatus() {
        if (this.userInfo.review != 2) {
          return false;
        }
        if (!permission(['contract', 'apply/:id?'], 'bind_company') && !this.userInfo.companys) {
          return false;
        }
        return true;
      },
    },
    async mounted() {
      this.contractStatus = (await contract_statuss({ current: -1 })).data || [];
      if (!this.store.getters.getConfig.is_header) {
        history.pushState(null, null, document.URL);
        window.addEventListener(
          'popstate',
          function (e) {
            history.pushState(null, null, document.URL);
          },
          false,
        );
      }
    },
    activated() {
      this.statusKey = '';
      this.gets();
      this.$store.dispatch('user/getUserInfoAction');
    },

    watch: {
      queryParam(a) {
        console.log(a);
      },
    },
    methods: {
      toggleSearchBox() {
        this.isCollapsed = !this.isCollapsed;
      },
      permission,
      findByKey,
      async gets(current) {
        this.loading = true;
        if (current) {
          this.pagination.current = current;
        }
        this.search = this.queryParam.custom.search;
        let res = await contracts({
          current: this.pagination.current,
          pageSize: this.pagination.pageSize,
          qp: JSON.stringify(this.queryParam),
        });
        this.totalPoundage = res.sum || 0;
        this.list = res.data || [];
        console.log(this.list);
        this.$set(this.pagination, 'total', res.total);
        this.loading = false;
        this.resetStatus();
      },
      formatTotalText(total) {
        if (!total) {
          return '';
        }
        return `合计担保费: ${this.totalPoundage}元 | 共 ${total} 条数据`;
      },
      applyModalOk() {
        if (this.apply_radio_value == 1) {
          this.$router.push('/admin/othercontract_apply/0');
        } else {
          this.$router.push('/admin/contract_apply');
        }
        this.applyModalFlag = false;
      },
      statusTabClick(e) {
        if (this.statusKey != e) {
          this.statusKey = e;
          this.queryParam.in.status = [];
          if (e == 14) {
            this.queryParam = merge(this.queryParam, {
              in: { status: [8, 9, 10, 11, 12, 14] },
            });
          } else if (e == 5) {
            this.queryParam = merge(this.queryParam, { in: { status: [5, 6] } });
          } else if (e == '') {
            this.queryParam = merge(this.queryParam, { in: { status: null } });
          } else {
            this.queryParam = merge(this.queryParam, { in: { status: [e] } });
          }
          this.gets(1);
        }
      },
      async resetStatus() {
        const queryParam = JSON.parse(JSON.stringify(this.queryParam));
        queryParam.in.status = [];
        const statuss = await contractStatusCount({
          qp: JSON.stringify(queryParam),
        });
        this.tabs.map((v) => {
          const result = statuss.find((value) => v.key == value.status);
          result && (v.count = result.count);
        });
      },
      applyModalCancel() {
        this.applyModalFlag = false;
      },
      godetail(record) {
        if (record.category_id == 2 || record.is_contract || record.status > 4) {
          this.$router.push(`/admin/contract_detail/${record.id}`);
        } else {
          this.$router.push(`/admin/othercontract_apply/${record.id}`);
        }
      },
      reset() {
        this.queryParam = { custom: { search: '', offset_months: '-3' }, time: {}, in: {}, like: {} };
        this.statusKey = '';
        this.gets(1);
      },
      apply() {
        // this.$router.push('/admin/contract_apply');
        this.applyModalFlag = true;
      },
      async exportReport() {
        this.spinning = true;
        try {
          const url = await exportContracts({
            qp: JSON.stringify(this.queryParam),
          });
          downloadUrl(this.$ossUrl + '/' + url, '保函订单报表.xlsx');
        } catch (error) {
          this.$message.error('报表导出失败:' + error.message);
        } finally {
          this.spinning = false;
        }
      },
      preview(record) {
        this.previewInfo = record;
        this.previewflag = true;
      },
      download(record) {
        this.downloadInfo = record;
        this.downloadflag = true;
      },
      press_enter(e) {
        e.preventDefault();
        this.gets(1);
      },
      confirmDelete(record) {
        this.$confirm({
          title: '温馨提示',
          content: '您确定要删除这条保函订单吗？',
          onOk: async () => {
            try {
              await contract_del({ id: record.id, version: record.version });
              this.$message.success('删除成功');
              this.gets();
            } catch (error) {
              this.$message.error('删除失败：' + error.message);
            }
          },
        });
      }
    },
  };
</script>
<style lang="less" scoped>
  .status-active {
    border: 2px solid #0960bd;
    color: #0960bd;
    border-radius: 10px;
    cursor: pointer;
  }

  .status {
    border: 2px solid transparent;
    cursor: pointer;
  }

  /deep/.action {
    vertical-align: baseline !important;
  }

  .search-container {
    align-items: start;
  }

  .search-box-wrapper {
    overflow: hidden;
    transition-property: height;
    transition-duration: 0.3s;
    transition-timing-function: ease-in-out;
  }
</style>
